import { ValueOf } from './types';

// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_AUTHORIZATION_TIMEOUT_MS = 120000;
export const INLINE_CALLBACK_MESSAGE_TYPE = 'flow_payment_sdk_inline_callback';
export const CALLBACK_ORIGIN = 'https://pay.flow.io';
export const FLOW_API_URI = 'https://api.flow.io';
export const SDK_PATH = '/sdk/v1';

export const errorCodes = {
  INVALID_PARAMETERS: 'INVALID_PARAMETERS',
  INVALID_RESPONSE_STATUS: 'INVALID_RESPONSE_STATUS',
  UNEXPECTED_ERROR: 'UNEXPECTED_ERROR',
} as const;
export type ErrorCodes = ValueOf<typeof errorCodes>;

export const BEARER_COOKIE = '_f60_bearer';

export const colors = {
  primaryBlue: 'rgba(0,81,178,1)',
  primaryBlueHover: 'rgba(0,81,178,0.9)',
  primaryBlueActive: 'rgba(0,81,178,1)',
};
